const COLLECTIONS = {
  USERS: 'users'
}

export default COLLECTIONS
